export default __webpack_public_path__ + "static/media/content-section_full-width-padded.3fb3d653.svg";